<template lang="pug">
    v-flex(xs12 sm12 md6)
        v-text-field(:value="value"
        autofocus
        :loading="loading"
        type="search"
        @change="onChange"
        @keydown.enter="onSearchEnter"
        solo
        :hide-details="true"
        persistent-hint
        prepend-inner-icon="mdi-magnify"
        :label="searchLabel")
            template(#append-outer v-if="!hideFilter")
                v-menu
                    template(#activator='{ on: menu }')
                        v-tooltip(bottom)
                            template(#activator='{ on: tooltip }')
                                v-btn(v-on='{ ...tooltip, ...menu }' icon style="top: -5px" :loading="loading" @click="showAdvanceSearchDialog")
                                    v-icon mdi-tune
                            span {{advanceSearchHint}}
</template>

<script>
export default {
  name: "SearchBox",
  props: {
    searchLabel: String,
    advanceSearchHint: String,
    loading: Boolean,
    value: String | null,
    hideFilter: Boolean
  },
  model: {
    prop: "value",
    event: "change"
  },
  methods: {
    onChange(value) {
      this.$emit("change", value);
    },
    onSearchEnter(value) {
      this.$emit("search", value);
    },
    showAdvanceSearchDialog() {
      this.$emit("setting");
    }
  }
};
</script>

<style scoped></style>
